import { Controller } from "@hotwired/stimulus"
import { show_error, hide_messages } from "lib/helpers"

// account-managements--form on accounts management edit form workspace.
export default class extends Controller {
  static targets = ["removeModal", "removeForm", "trialPicker"]

  static values = {
    syncStatsUrl: String,
  }

  connect() {
    if (this.hasRemoveModalTarget) {
      $(this.removeModalTarget).on("hidden.bs.modal.accountManagementsForm", () => {
        if (this.hasRemoveFormTarget) this.removeFormTarget.reset()
        hide_messages()
      })
    }
    this.#initRemoveAccountForm()
    this.#initTrialPeriodPicker()
  }

  disconnect() {
    if (this.hasRemoveModalTarget) {
      $(this.removeModalTarget).off(".accountManagementsForm")
    }
    if (this.hasRemoveFormTarget) $(this.removeFormTarget).ajaxFormUnbind()
    if (this.hasTrialPickerTarget && $(this.trialPickerTarget).data("xdsoft_datetimepicker")) {
      $(this.trialPickerTarget).datetimepicker("destroy")
    }
  }

  syncStats(event) {
    event.preventDefault()
    const link = event.currentTarget
    link.classList.add("disabled")

    $.ajax({
      url: this.syncStatsUrlValue,
      dataType: "JSON",
      success() {
        const parent = link.parentElement
        const info = document.createElement("span")
        info.style.fontSize = "10px"
        info.innerText = "Reload page to check syncing"
        parent.appendChild(info)
      },
    })
  }

  showRemoveAccountModal(event) {
    event.preventDefault()
    $(this.removeModalTarget).modal("show")
  }

  #initRemoveAccountForm() {
    if (!this.hasRemoveFormTarget) return

    $(this.removeFormTarget).ajaxForm({
      dataType: "json",
      success: (response) => {
        if (response.success) {
          this.removeModalTarget.innerHTML = response.template
        } else {
          show_error(response.message)
          $(this.removeFormTarget).find("input[type='submit']").enable(true)
        }
      },
      error: () => {
        show_error("An error occurred during request")
      },
    })
  }

  #initTrialPeriodPicker() {
    if (!this.hasTrialPickerTarget) return

    const $picker = $(this.trialPickerTarget)
    $picker.datetimepicker({
      onClose: (ct) => {
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        if (ct <= today) {
          $picker.datetimepicker({ value: this.#formatDate(new Date()) })
          $(".remaining_sma_trial_days").text("0 days")
        } else {
          const days = Math.round((ct - today) / (1000 * 60 * 60 * 24))
          $(".remaining_sma_trial_days").text(`${days} days`)
        }
      },
      timepicker: false,
      format: "d.m.Y",
      formatDate: "d.m.Y",
      closeOnDateSelect: true,
      minDate: 0,
      value: this.#formatDate($picker.val() ? new Date($picker.val()) : new Date()),
      mask: true,
    })
  }

  #formatDate(date) {
    let dd = date.getDate()
    let mm = date.getMonth() + 1
    const yy = date.getFullYear()
    if (dd < 10) dd = `0${dd}`
    if (mm < 10) mm = `0${mm}`
    return `${dd}.${mm}.${yy}`
  }
}
